import { Intent } from '@blueprintjs/core';

export default function (error, options) {
  const title = 'The resource has not been found';
  const description = 'The requested resource has not been found.';
  const message = 'The resource has not been found.';

  return {
    title,
    description,
    message,
    toast: false,
    intent: Intent.WARNING,
  };
}
